// @ts-strict-ignore
import { isServerSide } from '~/utils/next';

let cachedEnv = {};

const isPublicEnvKey = (key: string) => key.startsWith('NEXT_PUBLIC_') || ['NODE_ENV', 'ENV'].includes(key);

export const loadPublicEnv = (env: Record<string, string>) => {
  cachedEnv = env;
};

// The runtime public env only exists in the server's `process.env`: the client bundle is built without the deploy
// env. `_app.getInitialProps` also runs in the browser, to render a 404 or an error page after a client navigation:
// there, keep the env loaded at hydration rather than wipe it, default business unit included.
export const getPublicEnv = (): Record<string, string> =>
  isServerSide() ? Object.fromEntries(Object.entries(process.env).filter(([key]) => isPublicEnvKey(key))) : cachedEnv;

export const getEnv = (name: string, defaultValue?: string): string =>
  (cachedEnv[name] ?? process.env[name]) || defaultValue;

export const isProduction = () => getEnv('ENV') === 'production';
